import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { Event } from '@dadohr/shared/domainTypes/event';
import {
  EnrollSourceType,
  EventChannel,
  ExperienceEventType
} from '@dadohr/shared/domainTypes/experience';

export const toEventDoc = generateToDocFn<Event>((d) => {
  if (d.kind === 'EXPERIENCE') {
    if (d.type === ExperienceEventType.EXP_ENROLL) {
      d.source = d.source || { type: EnrollSourceType.UNKNOWN };
    }
    if (d.type === ExperienceEventType.SUB_TASK_DONE) {
      d.channel = d.channel || EventChannel.UNKNOWN;
    }
  }
  return d;
});
